import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

interface RTLWrapperProps {
  children: React.ReactNode;
}

export default function RTLWrapper({ children }: RTLWrapperProps) {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  useEffect(() => {
    // Set document direction and overflow
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;

    // Force body overflow settings
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflowX = 'hidden';

    // Add RTL class to body for CSS targeting
    if (isRTL) {
      document.body.classList.add('rtl-mode');
      document.documentElement.classList.add('rtl-mode');
    } else {
      document.body.classList.remove('rtl-mode');
      document.documentElement.classList.remove('rtl-mode');
    }

    return () => {
      document.body.classList.remove('rtl-mode');
      document.documentElement.classList.remove('rtl-mode');
    };
  }, [i18n.language, isRTL]);

  return (
    <div
      dir={isRTL ? 'rtl' : 'ltr'}
      className={`rtl-container ${isRTL ? 'rtl' : 'ltr'}`}
      style={{
        width: '100vw',
        maxWidth: '100vw',
        overflowX: 'hidden',
        position: 'relative',
      }}
    >
      {children}
    </div>
  );
}
